import React,{useState,useEffect} from "react";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  import { useDispatch,useSelector } from 'react-redux';
import Profile from "../Dashboard/Profile/Profile";
import CRMLogin from "./CRMlogin";
  
import {  Link  } from "react-router-dom";
import { checkLeadManagerLoginStatus } from "../../store/actions/CRM/checkLeadManagerLoginStatus";
import Loading from "../Loading/Loading";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus} from 'lucide-react';
   import { AllLeadState } from "./allLeadStates";
   import { AllLeadMaharashtraCities,AllLeadKarnatakaCities } from "./allLeadCities";
import SelectOptionCard from "./SelectOptionCard";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Snackbar from "../../Snackbar";
import { createALeadByManager } from "../../store/actions/CRM/createALeadByManager";
import { getLeadsBySearchParameter } from "../../store/actions/CRM/getLeadsBySearchParameter";

 const CreateLead = ({baseUrl})=>{
      const [open , setOpen]=useState(false);
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
   
            const history = useHistory();
     const [snackbarVisible, setSnackbarVisible] = useState(false);
       const [snackbarColor, setSnackbarColor] = useState("#958FDA");
       const [responseMessage, setResponseMessage] =useState("");
     
     const showSnackbar = () => {
       setSnackbarVisible(true);
     };
    
     const hideSnackbar = () => {
       setSnackbarVisible(false);
     };
  const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
    {
      
      dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
      dispatch({type: "CURSOR",payload:true  });
  
      dispatch({type: "CURSORTEXT",payload:CursorText})
      dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
      dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
    }
     
    const handleMouseLeave = () => {
      dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
      
      dispatch({type: "CURSOR",payload:false})
  
      dispatch({type: "CURSORTEXT",payload:""})
  
      dispatch({type: "CURSORTEXTBG",payload:""})
      dispatch({type: "CURSORTEXTCOLOR",payload:""})
    
  
  }
   const [loader , setLoader] =useState({status:false});
   
      const [statusData , setStatusData] =useState({status:false});
   const [stateName , setStateName] =useState("Delhi");
   const [cityName , setCityName] =useState("Delhi");
   const [openStatePopUp , setOpenStatePopUp] =useState(false);
   const [openCityPopUp , setOpenCityPopUp] =useState(false);
   
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
   const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 
    const {url,path} =useRouteMatch();
     
     
   const CRMtoken= useSelector((state)=>state?.crmData?.crmPass);
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
        
   const userdata = useSelector((state)=>state?.user?.user);
 const userEmail = useSelector((state)=>state?.user?.user?.user_email);

 const [leadName, setLeadName] = useState("");
 const [hasWebsite, setHasWebsite] = useState("");
 const [openHasWebsite, setOpenHasWebsite] = useState(false);
 
 const [addedInfo, setAddedInfo] = useState("");
 const [openForm, setOpenForm] = useState(false);
 const [ leadMobileNo, setLeadMobileNo] = useState("");
   const [ leadRefLink, setLeadRefLink] = useState("");
   const [ leadAddress, setLeadAddress] = useState("");
   const [ leadWhatsAppNo, setLeadWhatsAppNo] = useState("");
   const [ leadEmailId, setLeadEmailId] = useState("");
   const [leadExtraMemberArr, setLeadExtraMemberArr] = useState([]);


 function generateTimestamp() {
  return Math.floor(Date.now() / 1000);
}

const removeLeadExtraMember= (id) => {
  const filteredLeadExtraMember = leadExtraMemberArr.filter(item => item.id !== id);
  setLeadExtraMemberArr(filteredLeadExtraMember);
};
const updateLeadExtraMemberName = (id, memberName) => {
  const updatedLeadExtraMember = leadExtraMemberArr.map(item =>
    item.id === id ? { ...item, memberName :memberName } : item
  
  ); 
  
  setLeadExtraMemberArr(updatedLeadExtraMember);
};
const updateLeadExtraMemberContactNo= (id, memberContactNo) => {
  const updatedLeadExtraMember= leadExtraMemberArr.map(item =>
    item.id === id ? { ...item, contactNo :memberContactNo } : item
  
  ); 
  
  setLeadExtraMemberArr(updatedLeadExtraMember);
};

const leadExtraMemberData = leadExtraMemberArr!=[]?Object.values(leadExtraMemberArr):'';



     useEffect(() => {
      
        // setLeadExtraMemberArr([{ no:1, id: generateTimestamp()
        //   ,memberName:"",role:"",contactNo:"" },]);


        },[])
const handleCreateLead=(e)=>{
  


setLoader({status:true});
  const user = dispatch(createALeadByManager({
    leadState:stateName,leadCity:cityName,leadName:leadName,hasWebsite:hasWebsite,addedInfo:addedInfo,leadMobileNo:leadMobileNo,
    leadRefLink:leadRefLink,leadAddress:leadAddress,leadWhatsAppNo:leadWhatsAppNo,leadEmailId:leadEmailId,
    leadExtraMembers:JSON.stringify(leadExtraMemberArr),
    leadId:"",
    userEmail:userEmail,
    currentToken:currentToken,CRMtoken:CRMtoken,
    editType:'',appToken:AppToken,menuOrder:0}));
  /* get response as Promise   */
  user.then(response => {

    if(response?.leads){
    setResponseMessage(response?.message);
    setSnackbarColor(response?.color);
  //  console.log(response?.leads)
  
   // 
   if(response?.logout){
    
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});
      history.push(`/dashboard/`)
    },3000);
    
  }
/* resetting Login input Fields */

setLoader({status:false});

setSnackbarVisible(true);

setTimeout(()=>{
 
  
  setSnackbarVisible(false);
  setOpenForm(false)
  setLeadName("")
  setLeadEmailId("")
  setLeadExtraMemberArr("")
  setLeadMobileNo("")
  setLeadWhatsAppNo("")
  setHasWebsite("")
  setLeadAddress("")
  setLeadRefLink("")
 setAddedInfo("")
},1000)
    }else{
    
setLoader({status:false});

setSnackbarVisible(true);setOpenForm(false)
      setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
setLoader({status:false});
setOpenForm(false)
    console.error(error);
  });
 
  }
const handleSearchCheckMobileNo=(e)=>{

console.log({leadWhatsAppNo:leadWhatsAppNo,
    
  userEmail:userEmail,
  currentToken:currentToken,CRMtoken:CRMtoken,appToken:AppToken,
  filter:"checkWhatsAppNo"})

setLoader({status:true});

  const user = dispatch(getLeadsBySearchParameter({leadWhatsAppNo:leadWhatsAppNo,
    
    userEmail:userEmail,
    currentToken:currentToken,CRMtoken:CRMtoken,appToken:AppToken,
    filter:"checkWhatsAppNo"}));
  /* get response as Promise   */
  user.then(response => {
    console.log(response)
    if(response){
    setResponseMessage(response?.message);
    setSnackbarColor(response?.color);
    setOpenForm(response?.openForm)
   // 
   if(response?.logout){
    
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});
      history.push(`/dashboard/`)
    },3000);
    
  }
/* resetting Login input Fields */

setLoader({status:false});

setSnackbarVisible(true);

setTimeout(()=>{
 
  
  setSnackbarVisible(false);

},1000)
    }else{
    
setLoader({status:false});

setSnackbarVisible(true);
      setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
setLoader({status:false});
    console.error(error);
  });
 
  }


  useEffect(() => {
     setOpen(false) 
  setLoader({status:true});
  const LeadManagerLoginStatusData= {userEmail:userdata?.user_email,CRMtoken:CRMtoken,currentToken:currentToken}
     const user = dispatch(checkLeadManagerLoginStatus(LeadManagerLoginStatusData));
     /* get response as Promise   */
     user.then(response => {
     // pop up with message 
     //   console.log(response)
     setStatusData(response)
 
     if(response?.crmAccessStatus=='yes'){}else{ history.push(`${baseUrl}/crm-login`);}
    
      setInterval(()=>{
       // hide poped message 
       
      },3000)
      
  
   
   setLoader({status:false});
   
   
   
     }).catch(error => {
       
   /* resetting Login input Fields */
   //setLogin({user_email:'',user_pass:""
   
   // })
   setLoader({status:false});
       console.error(error);
     });
    
 
 
 
   }, []);
  
   


    return <>
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
{statusData?.crmAccessStatus=='yes'?
<div>
    <div className="outer-right">
       

    
<div className="outer-profile content-top" >
<div className="outer-profile-in  " style={{background:"#fff",padding:"0px",marginTop:"5px",marginBottom:"5px"}}>
 
    <div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
  <div align="left">

  <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="crm-button-two" 
      style= {{fontSize:"18px",textAlign:"left"}} placeholder="Add Whatsapp No To Check"  type="text"
  name="leadMobileNo" value={leadWhatsAppNo}
  onChange={(e)=>setLeadWhatsAppNo(e.target.value)}  />
  </div><div align="right">
<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={handleSearchCheckMobileNo}  style={{width:"170px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn">Check Whatsapp No</button>

  
</div>
</div>

 </div>
          
	  


        
<div  className=" outer-profile-in" style={{background:"#f1f1f1",padding:"0px",marginTop:"5px",marginBottom:"5px"}} >


<div className="outer-profile-subvals outer-profile-title ">
    <h3>{"Hey "+(userdata?.first_name?userdata?.first_name:" There! ")+" Welcome to  classmock.com" }</h3>
    </div>
  
{/* 


<div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
  <div></div>
<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={{}} 
     className="crm-button-two"  type="submit"
     id="signupBtn">Clear All</button>

  
   </div> */}
        
     </div>
    
    
    
     </div>
    <div>
    {openForm?
    <div className="leadItemOuterAll  ">
   
<div className="outer-profile-in  "><div className="padTenLead"><h3>
          Add LEAD Info </h3>
          <div  style={{cursor:"pointer"}} >Lead State/UT/City</div> 
 <div className="leadItemThree"   >
 
          <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead State"  type="text"
  name="LeadState" value={stateName}
   onClick={(e)=>setOpenStatePopUp(true)} /><input onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
    style= {{fontSize:"18px",}} placeholder="Lead City"  type="text"
name="LeadCity" value={cityName}
 onClick={(e)=>setOpenCityPopUp(true)} /> </div>
 
        <div>
        <div  style={{cursor:"pointer"}} >Lead Mobile No</div> 
        <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Mobile No" type="text"
  name="LeadMobileNo" 
   onChange={(e)=>setLeadMobileNo(e.target.value)} />
       <div  style={{cursor:"pointer"}} >Lead Institute Or Person Name</div> 
        <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Institute Or Person Name" type="text"
  rows={2} name="LeadInstituteName" value={leadName}
   onChange={(e)=>setLeadName(e.target.value)} />
  <div  style={{cursor:"pointer"}} >Lead Reference Link</div> 
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Reference Link" type="text"
  rows={2} name="LeadLink" value={leadRefLink}
   onChange={(e)=>setLeadRefLink(e.target.value)} />
     <div  style={{cursor:"pointer"}} >Already Has Website???  {openHasWebsite?<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={()=>setOpenHasWebsite(false)} style={{width:"60px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn"> No </button>:<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={()=>setOpenHasWebsite(true)} style={{width:"60px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn"> Yes </button>} </div> 
{openHasWebsite?<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Web Link" type="text"
  rows={2} name="LeadWebLink" value={hasWebsite}
   onChange={(e)=>setHasWebsite(e.target.value)} />:""}
   
     
     
        </div>

   <div>
    
   
   </div></div></div>

<div className="outer-profile-in  ">
  
<div className="padTenLead">
<div  style={{cursor:"pointer"}} >Lead Address</div> 
          <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Address" type="text"
  rows={4} name="LeadLink" value={leadAddress}
   onChange={(e)=>setLeadAddress(e.target.value)} />
<div  style={{cursor:"pointer"}} >Lead Added Info</div> 
          <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Added Info " type="text"
  rows={4} name="LeadaddedInfo" value={addedInfo}
   onChange={(e)=>setAddedInfo(e.target.value)} />
<div  style={{cursor:"pointer"}} >Lead Whatsapp No</div> 
<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Whatsapp No" type="text"
  name="LeadWhatsappNo" value={leadWhatsAppNo}
   onChange={(e)=>setLeadWhatsAppNo(e.target.value)} />
   <div  style={{cursor:"pointer"}} >Lead Email Id</div> 
<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Lead Email Id" type="text"
  name="LeadEmailId" value={leadEmailId}
   onChange={(e)=>setLeadEmailId(e.target.value)} />
<div className="leadFlexTwo" 
         ><h3>
          Add LEAD Members   </h3>
       
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  
     onClick={()=>setLeadExtraMemberArr([...leadExtraMemberArr,
       {no: leadExtraMemberArr.length, id: generateTimestamp()+leadExtraMemberArr.length
      , memberName:"",role:"",contactNo:""  }])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginTop:"5px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
{leadExtraMemberData?leadExtraMemberData.map((item, index) => 
        (<div className="leadItemTwo"  index={index} key={item.id} 
         >
            

<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Member Name" type="text"
  name="LeadName" value={item.memberName}
  onChange={(e)=>updateLeadExtraMemberName(item.id,e.target.value)} />

<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder="Contact No" type="number"
  name="LeadContact" value={item.contactNo}
  onChange={(e)=>updateLeadExtraMemberContactNo(item.id,e.target.value)} />
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   onClick={()=>removeLeadExtraMember(item.id)}
   style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginTop:"5px",
        background:"#fff",border:"2px dashed #958FDA"}} > <X  style={{margin:"9px"}}  color="#958FDA" size={22}/></div>

            {/* <div> 
              <WhatWillYouLearnAddMore index={index} key={item.id} 
        
         paragraph={item.paragraph}  id={item.id} 
           changeItemParagraph={updateItemParagraph } onRemove={removeItem} />
          </div> */}
          
          </div>)):'' }


<div className="gridForSidebarItemBottom" style={{paddingTop:'15px',fontSize:'12px',marginBottom:'10px'}}>
   
   {/* <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}  
     className="buttonEmptySidebar"  type="submit"
     id="signupBtn"> Close </button>
  */}

  <div></div>
 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={handleCreateLead} style={{width:"140px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn"> {loader?.status?"Creating  ... ":"Click To Create"} </button>
  </div>
</div>
</div> 
       {openStatePopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:999999}} onClick={()=>{setOpenStatePopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div align="center" className="outer-profile-title ">Select A State/UT</div>
        <div  className= "input-card-radio-two "   
>  
{AllLeadState.map((f)=>
        
<SelectOptionCard name={stateName} title={f.stateName}  
   setName={(val)=>{setStateName(val);setCityName(f.mainCity)}} 
   setOpenPopUp={(val)=>setOpenStatePopUp(val)}  />)
 }
  </div>
        </div> </div>:""
        }
            


             {openCityPopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:999999}} onClick={()=>{setOpenCityPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div align="center" className="outer-profile-title ">Select A City In {stateName}</div>
        <div  className= "input-card-radio-two "   
>  
{stateName=="Maharashtra"?AllLeadMaharashtraCities.map((f)=>
            
<SelectOptionCard name={cityName} title={f.cityName}  
   setName={(val)=>setCityName(val)} 
   setOpenPopUp={(val)=>setOpenCityPopUp(val)}  />):
   stateName=="Karnataka"?AllLeadKarnatakaCities.map((f)=>
            
    <SelectOptionCard name={cityName} title={f.cityName}  
       setName={(val)=>setCityName(val)} 
       setOpenPopUp={(val)=>setOpenCityPopUp(val)}  />) :""
 }
  </div>
        </div> </div>:""
        }
                  
                <div className="content-bottom">

        </div>
    </div>:<h1>{responseMessage}</h1>}
    <div>
      </div>
      </div>
     </div>


</div>
:""
}
   
    </>

}
export default CreateLead;
